export class TheatreBasketPackService {
    serviceId: number;
    barcode: string;
    name: string;
    packId: number;
    packBasketId: string;
    userName: string;
  }
  